/*
 * SCK accessory upsell enhancement (Oct 19/20)
 * Scope: the Selleasy offers listed in SCKAccUpsellConfig.offers only
 *   offer#6640237e "Accessories for Cleats", offer#cea77ce3 "Accessories for Non-Cleated Footwear".
 *
 * Selleasy remains responsible for eligibility, random rotation, max-2, cart exclusion,
 * product/variant data, prices, availability, add-to-cart, its after-add behavior and tracking.
 * This file only:
 *   - swaps in each offer's English heading/subtitle, and display titles, benefit lines and
 *     button labels mapped by Shopify product ID (never by card position);
 *   - for products configured with `choices` (Blumaka), shows one labeled select per option,
 *     built from Selleasy's own list of available variants, with no preselected default; once
 *     every option is chosen it sets Selleasy's own (hidden) select, so Selleasy updates the
 *     variant and price and performs the add. Until then the add button is held with a hint;
 *   - adds a visible + announced loading state, a repeat-click guard, and success/error feedback.
 *
 * Idempotent: safe to run many times; no polling. One MutationObserver per app-block wrapper.
 * Text is changed by editing Selleasy's existing text nodes in place, so Selleasy's own
 * later updates to those nodes still render.
 */
(function () {
  'use strict';
  if (window.SCKAccUpsell) return;
  var cfg = window.SCKAccUpsellConfig;
  if (!cfg || !cfg.offers) return;

  var OFFER_KEYS = Object.keys(cfg.offers);
  var TX = cfg.text || {};
  var ACTION_TEXTS = [].concat(cfg.actionText || []);
  function fill(tpl, title) { return String(tpl).split('[title]').join(title); }
  var PENDING_KEY = 'sck-acc-pending';
  var TIMEOUT_MS = 10000;
  var bound = new WeakSet();

  function firstTextNode(el) {
    if (!el) return null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.data.trim()) return n;
    }
    return null;
  }

  function setText(el, text) {
    if (!el || text == null) return;
    var node = firstTextNode(el);
    if (node) {
      if (node.data !== text) node.data = text;
    } else if (!el.children.length && el.textContent !== text) {
      el.textContent = text;
    }
  }

  function offerKeyOf(w) {
    var o = w.getAttribute('offer') || '';
    for (var i = 0; i < OFFER_KEYS.length; i++) if (o.indexOf(OFFER_KEYS[i]) === 0) return OFFER_KEYS[i];
    return null;
  }

  function widgetIn(wrapper) {
    var list = wrapper.querySelectorAll(':scope > lb-upsell-widget[offer]');
    for (var i = 0; i < list.length; i++) if (offerKeyOf(list[i])) return list[i];
    return null;
  }

  function statusEl(wrapper) {
    var el = wrapper.querySelector(':scope > .sck-acc-status');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sck-acc-status';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      wrapper.insertBefore(el, wrapper.firstChild);
    }
    return el;
  }

  function showStatus(wrapper, tone, html) {
    var el = statusEl(wrapper);
    el.setAttribute('data-tone', tone);
    el.innerHTML = html;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Per-option selects (Blumaka) ---------- */

  // Selleasy's select lists only available variants; each option's text is the variant title
  // ("Max Cushion / Low / Men's 9-9.5 | Women's 10-10.5") and its value is the variant ID.
  function readVariants(sel) {
    var out = [];
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (!o.value || o.disabled) continue;
      out.push({ id: o.value, parts: o.text.split(' / ').map(function (x) { return x.trim(); }) });
    }
    return out;
  }

  function optionNames(sel, count) {
    var label = (sel.getAttribute('aria-label') || '').replace(/\s+for\s+.*$/, '');
    var names = label.split(' / ').map(function (x) { return x.trim(); });
    if (names.length !== count) {
      names = [];
      for (var i = 0; i < count; i++) names.push('Option ' + (i + 1));
    }
    return names;
  }

  function getChoices(card, n) {
    var c = [];
    for (var i = 0; i < n; i++) c.push(card.getAttribute('data-sck-choice-' + i) || '');
    return c;
  }

  function matches(v, choices, skip) {
    for (var i = 0; i < choices.length; i++) {
      if (i === skip || !choices[i]) continue;
      if (v.parts[i] !== choices[i]) return false;
    }
    return true;
  }

  function refreshChoices(card, m) {
    var sel = card.querySelector('lb-variant-picker select.lb-variant-picker');
    var box = card.querySelector('.sck-acc-choices');
    if (!sel || !box) return;
    var variants = readVariants(sel);
    var selects = box.querySelectorAll('select.sck-acc-choice-select');
    var n = selects.length;
    var choices = getChoices(card, n);

    // Drop any choice that no longer leads to an available variant (e.g. size after an arch change).
    for (var i = 0; i < n; i++) {
      if (choices[i] && !variants.some(function (v) { return v.parts[i] === choices[i] && matches(v, choices, i); })) {
        choices[i] = '';
        card.removeAttribute('data-sck-choice-' + i);
      }
    }
    for (var s = 0; s < n; s++) {
      var opts = selects[s].options;
      for (var k = 1; k < opts.length; k++) {
        var val = opts[k].value;
        var ok = variants.some(function (v) { return v.parts[s] === val && matches(v, choices, s); });
        if (opts[k].disabled === ok) opts[k].disabled = !ok;
      }
      if (selects[s].value !== choices[s]) selects[s].value = choices[s];
    }

    var match = null;
    if (choices.every(Boolean)) {
      match = variants.filter(function (v) { return v.parts.every(function (p, i) { return p === choices[i]; }); })[0] || null;
    }
    if (match) {
      card.removeAttribute('data-sck-needs-choice');
      var hint = box.querySelector('.sck-acc-choice-hint');
      if (hint && !hint.hidden) hint.hidden = true;
      if (sel.value !== match.id) {
        sel.value = match.id;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Selleasy applies the new variant asynchronously; hold the add button until its own
      // variant matches the customer's choice, so a fast click can never add the previous one.
      var synced = card.getAttribute('lb-variant-id') === match.id;
      if (synced && card.hasAttribute('data-sck-syncing')) card.removeAttribute('data-sck-syncing');
      if (!synced && !card.hasAttribute('data-sck-syncing')) card.setAttribute('data-sck-syncing', '');
    } else {
      if (!card.hasAttribute('data-sck-needs-choice')) card.setAttribute('data-sck-needs-choice', '');
      if (card.hasAttribute('data-sck-syncing')) card.removeAttribute('data-sck-syncing');
    }
  }

  function setupChoices(card, m) {
    var sel = card.querySelector('lb-variant-picker select.lb-variant-picker');
    var host = card.querySelector('lb-variant-picker');
    if (!sel || !host) return;
    var variants = readVariants(sel);
    if (!variants.length) return;
    var n = variants[0].parts.length;
    if (n < 2) return; // single-option products keep Selleasy's own dropdown
    if (!card.classList.contains('sck-acc-split')) card.classList.add('sck-acc-split');

    var box = card.querySelector('.sck-acc-choices');
    if (!box) {
      var names = optionNames(sel, n);
      var pid = card.getAttribute('lb-product-id');
      box = document.createElement('div');
      box.className = 'sck-acc-choices';
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', TX.chooseOptions || 'Choose options');
      for (var i = 0; i < n; i++) {
        var values = [];
        variants.forEach(function (v) { if (values.indexOf(v.parts[i]) === -1) values.push(v.parts[i]); });
        var label = document.createElement('label');
        label.className = 'sck-acc-choice';
        var name = document.createElement('span');
        name.className = 'sck-acc-choice-name';
        name.textContent = names[i];
        var s = document.createElement('select');
        s.className = 'sck-acc-choice-select';
        s.required = true;
        s.setAttribute('data-index', String(i));
        s.id = 'sck-acc-' + pid + '-opt-' + i;
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = (TX.selectOption && TX.selectOption !== 'Select [name]')
          ? TX.selectOption.split('[name]').join(names[i].toLowerCase())
          : ((m.choices && m.choices.prompt) || 'Select') + ' ' + names[i].toLowerCase();
        s.appendChild(ph);
        values.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val;
          o.textContent = val;
          s.appendChild(o);
        });
        label.appendChild(name);
        label.appendChild(s);
        box.appendChild(label);
      }
      var hint = document.createElement('p');
      hint.className = 'sck-acc-choice-hint';
      hint.id = 'sck-acc-' + pid + '-hint';
      hint.setAttribute('role', 'alert');
      hint.hidden = true;
      hint.textContent = (m.choices && m.choices.hint) || TX.chooseAll || 'Choose all options to add this item.';
      box.appendChild(hint);
      box.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.classList || !t.classList.contains('sck-acc-choice-select')) return;
        var idx = t.getAttribute('data-index');
        if (t.value) card.setAttribute('data-sck-choice-' + idx, t.value);
        else card.removeAttribute('data-sck-choice-' + idx);
        refreshChoices(card, m);
      });
      host.insertAdjacentElement('afterend', box);
    }
    if (!card.hasAttribute('data-sck-choices-init')) {
      card.setAttribute('data-sck-choices-init', '');
      card.setAttribute('data-sck-needs-choice', '');
    }
    refreshChoices(card, m);
  }

  /* ---------- Copy ---------- */

  function enhanceCard(card) {
    var id = card.getAttribute('lb-product-id');
    var m = cfg.items[id];
    if (m && cfg.en) {
      var titleEl = card.querySelector('.lb-card-title');
      setText(titleEl, m.title);
      if (titleEl && !titleEl.id) titleEl.id = 'sck-acc-title-' + id;

      var img = card.querySelector('.lb-card-img');
      if (img && !img.getAttribute('alt') && (m.title || titleEl)) img.setAttribute('alt', m.title || titleEl.textContent.trim());

      // Each mapped field is optional: products mapped only for a button label
      // (e.g. Sole Secure) keep Selleasy's own title and get no benefit line.
      var titleHost = card.querySelector('lb-card-title');
      var benefit = card.querySelector('.sck-acc-benefit');
      if (m.benefit) {
        if (!benefit && titleHost) {
          benefit = document.createElement('p');
          benefit.className = 'sck-acc-benefit';
          benefit.id = 'sck-acc-benefit-' + id;
          titleHost.insertAdjacentElement('afterend', benefit);
        }
        if (benefit && benefit.textContent !== m.benefit) benefit.textContent = m.benefit;
      } else {
        benefit = null;
      }

      if (m.choices) setupChoices(card, m);

      var btn = card.querySelector('lb-button .lb-button');
      if (btn) {
        var t = firstTextNode(btn);
        // Only relabel Selleasy's default "Add"; leave any other state it shows untouched.
        if (m.label && t && ACTION_TEXTS.indexOf(t.data.trim()) !== -1) t.data = m.label;
        var desc = (titleEl ? titleEl.id : '') + (benefit ? ' ' + benefit.id : '');
        if (card.hasAttribute('data-sck-needs-choice')) desc += ' sck-acc-' + id + '-hint';
        desc = desc.trim();
        if (desc && btn.getAttribute('aria-describedby') !== desc) btn.setAttribute('aria-describedby', desc);
        var needs = (card.hasAttribute('data-sck-needs-choice') || card.hasAttribute('data-sck-syncing')) ? 'true' : null;
        if (btn.getAttribute('aria-disabled') !== needs) {
          if (needs) btn.setAttribute('aria-disabled', needs); else btn.removeAttribute('aria-disabled');
        }
      }
    }
    if (!card.hasAttribute('data-sck-done')) card.setAttribute('data-sck-done', '');
  }

  function enhance(wrapper) {
    var w = widgetIn(wrapper);
    if (!w) return;
    var offer = cfg.offers[offerKeyOf(w)];
    var addon = w.querySelector('lb-addon');
    if (addon) {
      if (cfg.en && offer) {
        setText(addon.querySelector('.lb-addon-title'), offer.heading);
        setText(addon.querySelector('.lb-addon-subTitle'), offer.subtitle);
      }
      if (!addon.hasAttribute('data-sck-done')) addon.setAttribute('data-sck-done', '');
    }
    var cards = w.querySelectorAll('lb-upsell-flat-card[lb-product-id]');
    for (var i = 0; i < cards.length; i++) enhanceCard(cards[i]);
  }

  /* ---------- Add-to-cart feedback ---------- */

  function cartHas(productId) {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).some(function (i) { return String(i.product_id) === String(productId); });
      });
  }

  function successHtml(title) {
    return cfg.en
      ? '&#10003; ' + fill(TX.added || '[title] added to your cart.', escapeHtml(title)) + ' <a href="' + escapeHtml(cfg.cartUrl) + '">' + (TX.viewCart || 'View cart') + '</a>'
      : '&#10003; <a href="' + escapeHtml(cfg.cartUrl) + '">' + escapeHtml(title) + '</a>';
  }

  function errorHtml(title) {
    return cfg.en
      ? fill(TX.addError || 'Sorry, we couldn’t add [title] to your cart. Please try again.', escapeHtml(title))
      : '&#9888; ' + escapeHtml(title);
  }

  function clearBusy(card) {
    if (!card) return;
    card.removeAttribute('data-sck-busy');
    var btn = card.querySelector('lb-button .lb-button');
    if (btn) btn.removeAttribute('aria-busy');
  }

  function onActivate(wrapper, e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('lb-button .lb-button');
    var w = widgetIn(wrapper);
    if (!btn || !w || !w.contains(btn)) return;
    var card = btn.closest('lb-upsell-flat-card');
    if (!card) return;

    if (card.hasAttribute('data-sck-needs-choice')) {
      // Required options not chosen yet: never let Selleasy add its preselected default variant.
      e.preventDefault();
      e.stopImmediatePropagation();
      var hint = card.querySelector('.sck-acc-choice-hint');
      if (hint) hint.hidden = false;
      var firstEmpty = card.querySelector('select.sck-acc-choice-select:invalid');
      if (firstEmpty) firstEmpty.focus();
      return;
    }

    if (card.hasAttribute('data-sck-busy') || card.hasAttribute('data-sck-syncing')) {
      // A request for this card is already pending, or Selleasy is still applying the chosen
      // variant: block the activation.
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    var id = card.getAttribute('lb-product-id');
    var m = cfg.items[id];
    var title = (m && cfg.en && m.title) ? m.title : ((card.querySelector('.lb-card-title') || {}).textContent || '').trim();

    card.setAttribute('data-sck-busy', '');
    btn.setAttribute('aria-busy', 'true');
    if (cfg.en) showStatus(wrapper, 'info', fill(TX.adding || 'Adding [title] to your cart…', escapeHtml(title)));

    try {
      sessionStorage.setItem(PENDING_KEY, JSON.stringify({ id: id, title: title, ts: Date.now(), path: location.pathname }));
    } catch (err) { /* storage unavailable: feedback falls back to the timeout check */ }

    // Selleasy normally refreshes the page after adding (its "afterAction"). If it does not
    // within the timeout, check the cart ourselves and report the result.
    window.setTimeout(function () {
      if (!card.isConnected || !card.hasAttribute('data-sck-busy')) return;
      cartHas(id).then(function (has) {
        clearBusy(card);
        try { sessionStorage.removeItem(PENDING_KEY); } catch (err) {}
        showStatus(wrapper, has ? 'success' : 'error', has ? successHtml(title) : errorHtml(title));
      }).catch(function () {
        clearBusy(card);
        showStatus(wrapper, 'error', errorHtml(title));
      });
    }, TIMEOUT_MS);
  }

  function reportPending(wrapper) {
    var raw;
    try { raw = sessionStorage.getItem(PENDING_KEY); } catch (err) { return; }
    if (!raw) return;
    var p;
    try { p = JSON.parse(raw); } catch (err) { p = null; }
    try { sessionStorage.removeItem(PENDING_KEY); } catch (err) {}
    if (!p || p.path !== location.pathname || Date.now() - p.ts > 60000) return;
    cartHas(p.id).then(function (has) {
      showStatus(wrapper, has ? 'success' : 'error', has ? successHtml(p.title) : errorHtml(p.title));
    }).catch(function () {});
  }

  function bind(wrapper) {
    if (bound.has(wrapper)) { enhance(wrapper); return; }
    bound.add(wrapper);
    enhance(wrapper);
    // lb-variant-id is watched so the per-option selects release the add button as soon as
    // Selleasy has applied the chosen variant.
    new MutationObserver(function () { enhance(wrapper); })
      .observe(wrapper, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['lb-variant-id'] });
    var handler = function (e) { onActivate(wrapper, e); };
    wrapper.addEventListener('click', handler, true);
    wrapper.addEventListener('keydown', handler, true);
    reportPending(wrapper);
  }

  // The Selleasy app-block wrapper is server-rendered empty; Selleasy injects
  // <lb-upsell-widget offer="..."> into it at runtime. So bind to the wrapper and let
  // enhance() check for a configured offer on every pass (other offers are left untouched).
  function init(root) {
    var scope = root || document;
    var wrappers = scope.querySelectorAll('.shopify-app-block.lb-widget-cpal');
    for (var i = 0; i < wrappers.length; i++) bind(wrappers[i]);
  }

  window.SCKAccUpsell = { init: init };
  init();
  // Theme editor / section rendering API re-renders
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
